/* ==========================================================================
   Pflegewegweiser Kategorieseite

   - Filterleiste: Aufklapper, Sammelknopf, Filterblatt auf dem Handy
   - Filter, Sortierung und Nachladen ohne Seitenwechsel
   - Ratgebertext aus der Sammlungsbeschreibung in Kopf und Akkordeon umbauen

   Alles ist Aufsatz: ohne dieses Skript bleiben die Filter normale Links und
   die Seite funktioniert vollstaendig, nur eben mit Neuladen.
   ========================================================================== */

(function () {
  'use strict';

  var MOBIL = 999;

  /* --------------------------------------------- Was deckt oben wirklich ab?

     Kurze Antwort auf dieser Seite: nichts. Und daran hing die ganze Reihe von
     Fehlern mit der Filterleiste.

     Die Kopfzeile traegt zwar position:sticky, aber ihr Elternelement – der
     Abschnitts-Container von Shopify – ist exakt so hoch wie sie selbst
     (gemessen 133 zu 133 am Desktop, 161 zu 161 auf dem Handy). Ein klebendes
     Element kann sich nur innerhalb seines Elternelements halten; bei null
     Spielraum scrollt es sofort mit weg. Die Kopfzeile bleibt also nicht oben
     stehen, auch wenn die Klasse etwas anderes verspricht.

     Alle bisherigen Versuche haben einen Versatz fuer eine Kopfzeile
     ausgerechnet, die gar nicht da ist: mit ihrer Hoehe hing die Filterleiste
     133 beziehungsweise 161 Pixel unter dem oberen Rand mitten im Bild, mit
     ihrer Unterkante wanderte der Wert und die Leiste sprang. Richtig ist 0 –
     und das steht fest im CSS, ohne Messen, ohne Nachziehen.

     Diese Funktion bleibt fuer zwei andere Zwecke: den Schatten, sobald die
     Leiste klebt, und die Sprungweite beim Filtern. Sie meldet, wie viel von
     der Kopfzeile im Augenblick oben noch im Weg ist – solange sie sichtbar
     ist, ihre Unterkante, danach null. */
  function kopfHoehe() {
    var header = document.querySelector('[data-pww-header]');
    if (!header) return 0;

    var stil = window.getComputedStyle(header);
    if (stil.position !== 'sticky' && stil.position !== 'fixed') return 0;

    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  /* ----------------------------------------------------------- Akkordeons

     Eigene Umsetzung statt pww-product.js: auf der Kategorieseite wird die
     Produktseiten-Datei nicht geladen, und fuer ein Auf- und Zuklappen
     lohnen 76 KB nicht. Markup und Klassen sind dieselben. */
  function initAkkordeon(wurzel) {
    if (!wurzel || wurzel.dataset.pwwInit === 'true') return;
    wurzel.dataset.pwwInit = 'true';

    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-acc-btn]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pww-acc__item');
        if (!item) return;
        var offen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
      });
    });
  }

  function initAkkordeonAlle() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-acc]')).forEach(initAkkordeon);
  }

  /* -------------------------------------------------------------- Ratgeber

     Die Beschreibung der Sammlung ist bereits gegliedert: ein <section> je
     Abschnitt, darin eine Ueberschrift und der Text. Daraus wird hier Kopf,
     offener Teil und Akkordeon gebaut.

     Warum hier und nicht in Liquid: Liquid kann HTML nur als Zeichenkette
     zerschneiden. Eine zusaetzliche Ebene im Text – und sei es ein Absatz
     mehr – haette das Ergebnis zerlegt. Der Baum im Browser ist eindeutig.

     Faellt das Skript aus, bleibt der vollstaendige Text stehen. Fuer
     Suchmaschinen ist das ohnehin derselbe Inhalt: er steht im ausgelieferten
     HTML, nicht erst nach dem Umbau. */

  function textVon(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* Zerlegt den rohen Text in Bloecke mit Titel. Zwei Bauformen kommen vor:
     Abschnitte in <section>, oder eine flache Folge, die von Ueberschriften
     gegliedert wird. */
  function bloeckeLesen(roh) {
    var bloecke = [];
    var abschnitte = Array.prototype.slice.call(roh.children).filter(function (k) {
      return k.tagName === 'SECTION';
    });

    if (abschnitte.length > 1) {
      abschnitte.forEach(function (ab) {
        /* Die erste Ueberschrift mit Text, nicht einfach die erste: in der
           Beschreibung stehen vereinzelt leere <h3> vor der eigentlichen
           Ueberschrift. Wer die nimmt, haelt den Abschnitt fuer namenlos und
           klebt ihn an den vorherigen. */
        var kopf = null;
        Array.prototype.slice.call(ab.querySelectorAll('h2, h3, h4')).some(function (k) {
          if (!textVon(k)) return false;
          kopf = k;
          return true;
        });
        bloecke.push({
          titel: kopf ? textVon(kopf) : '',
          kopfEl: kopf,
          knoten: Array.prototype.slice.call(ab.childNodes)
        });
      });
      return bloecke;
    }

    /* Flache Folge: bei jeder Ueberschrift beginnt ein neuer Block. */
    var quelle = abschnitte.length === 1 ? abschnitte[0] : roh;
    var aktuell = null;
    Array.prototype.slice.call(quelle.childNodes).forEach(function (k) {
      var istKopf = k.nodeType === 1 && /^H[234]$/.test(k.tagName);

      /* Vor der ersten Ueberschrift steht meist nur ein Zeilenumbruch. Der ist
         kein Abschnitt – als solcher gezaehlt entstand daraus ein Akkordeon
         ohne Beschriftung, und die Ueberschrift darunter rutschte aus dem Kopf
         in einen eigenen Klappkasten. */
      if (!istKopf && !aktuell) {
        if (k.nodeType === 3 && !k.nodeValue.trim()) return;
        if (k.nodeType === 8) return;
      }

      if (istKopf || !aktuell) {
        aktuell = { titel: istKopf ? textVon(k) : '', kopfEl: istKopf ? k : null, knoten: [] };
        bloecke.push(aktuell);
      }
      aktuell.knoten.push(k);
    });
    return bloecke;
  }

  /* --------------------------------------------------- Word-Reste entfernen

     Teile der Kategorietexte sind aus Word einkopiert. Sie bringen eigene
     Schriftangaben mit ("font-family: Aptos", "18.0pt", mso-Eigenschaften) und
     packen Ueberschriften zusaetzlich in <b>. Sichtbar wurde das als fette
     Ueberschrift in fremder Schrift mitten im Ratgeber – gemessen bei "Pflege
     und Hygiene" 162 von 195 Elementen.

     Entfernt werden nur die Schrift- und Farbangaben. Ausrichtung und alles
     Uebrige bleibt, damit bewusst gesetzte Formatierungen nicht verloren
     gehen. Am gepflegten Text im Backend aendert das nichts. */
  var STIL_WEG = [
    'font',
    'font-family',
    'font-size',
    'font-weight',
    'line-height',
    'letter-spacing',
    'color',
    'background',
    'background-color',
    'text-transform'
  ];

  function wordPutzen(bereich) {
    if (!bereich) return;

    Array.prototype.slice.call(bereich.querySelectorAll('[style]')).forEach(function (el) {
      STIL_WEG.forEach(function (p) {
        el.style.removeProperty(p);
      });
      var rest = el.getAttribute('style') || '';
      if (!rest.trim()) el.removeAttribute('style');
    });

    /* Fettung in Ueberschriften aufloesen: die Ueberschrift ist schon durch
       ihre Groesse hervorgehoben, ein zusaetzliches <b> macht sie nur
       schwerer. Im Fliesstext bleibt Fettes erhalten – dort ist es gewollt. */
    Array.prototype.slice.call(bereich.querySelectorAll('h2, h3, h4')).forEach(function (h) {
      Array.prototype.slice.call(h.querySelectorAll('b, strong')).forEach(function (fett) {
        while (fett.firstChild) fett.parentNode.insertBefore(fett.firstChild, fett);
        fett.remove();
      });
    });
  }

  /* Erster Textknoten in Dokumentreihenfolge – auch wenn er in einem <strong>
     steckt, was in den gepflegten Texten oft vorkommt. */
  function ersterText(el) {
    for (var k = el.firstChild; k; k = k.nextSibling) {
      if (k.nodeType === 3) {
        if (k.nodeValue.trim()) return k;
        continue;
      }
      if (k.nodeType === 1) {
        var t = ersterText(k);
        if (t) return t;
      }
    }
    return null;
  }

  /* Doppelte Aufzaehlungszeichen entfernen: in den gepflegten Texten stehen
     Listenpunkte teils als "- Leicht: …" geschrieben, und die Liste setzt
     ihren eigenen Punkt davor. Sichtbar war dann "• - Leicht". Entfernt wird
     nur der geschriebene Strich am Anfang; der Punkt der Liste bleibt. */
  function listenpunkteEntdoppeln(bereich) {
    if (!bereich) return;
    Array.prototype.slice.call(bereich.querySelectorAll('li')).forEach(function (li) {
      var t = ersterText(li);
      if (!t) return;

      var sauber = t.nodeValue.replace(/^\s*[-–—•·*]\s+/, '');
      if (sauber !== t.nodeValue) {
        t.nodeValue = sauber;
        return;
      }

      /* Der Strich steht auch mal allein in einer Auszeichnung: <strong>-</strong>
         gefolgt vom eigentlichen Text. Dann fehlt das Leerzeichen dahinter und
         die Regel oben greift nicht. */
      if (!/^\s*[-–—•·*]\s*$/.test(t.nodeValue)) return;

      var traeger = t.parentNode;
      t.nodeValue = '';
      if (traeger !== li && !traeger.textContent.trim()) traeger.remove();

      /* Das Leerzeichen, das am Strich hing, gehoert mit weg. */
      var weiter = ersterText(li);
      if (weiter) weiter.nodeValue = weiter.nodeValue.replace(/^\s+/, '');
    });
  }

  /* Breite Tabellen bekommen ein eigenes Scrollfeld. Ohne das schiebt eine
     Tabelle mit fuenf Spalten die ganze Seite seitlich. */
  function tabellenFassen(bereich) {
    Array.prototype.slice.call(bereich.querySelectorAll('table')).forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains('pww-guide__tabelle')) return;
      var huelle = document.createElement('div');
      huelle.className = 'pww-guide__tabelle';
      t.parentNode.insertBefore(huelle, t);
      huelle.appendChild(t);
    });
  }

  function initGuide(guide) {
    if (!guide || guide.dataset.pwwInit === 'true') return;
    guide.dataset.pwwInit = 'true';

    var roh = guide.querySelector('[data-pww-guide-raw]');
    if (!roh) return;

    /* Zuerst die Word-Reste, dann zerlegen: sonst traegt jeder Abschnitt die
       fremden Schriftangaben in sein Klappfeld mit. */
    wordPutzen(roh);

    /* Leere Ueberschriften raus, bevor zerlegt wird – sie hinterlassen sonst
       eine Luecke im Text und im Akkordeon einen Knopf ohne Beschriftung. */
    Array.prototype.slice.call(roh.querySelectorAll('h2, h3, h4')).forEach(function (h) {
      if (!textVon(h)) h.remove();
    });

    var bloecke = bloeckeLesen(roh);
    if (!bloecke.length) return;

    /* Bloecke ohne eigene Ueberschrift gehoeren zum vorherigen – in der
       Beschreibung stehen vereinzelt Abschnitte mit leerem <h3>. Als eigenes
       Akkordeon waeren sie ein Knopf ohne Beschriftung. */
    var sauber = [];
    bloecke.forEach(function (b) {
      if (b.titel === '' && sauber.length) {
        sauber[sauber.length - 1].knoten = sauber[sauber.length - 1].knoten.concat(b.knoten);
        return;
      }
      sauber.push(b);
    });

    /* Der erste Block wird zum Kopf, wenn er die H2 traegt – oder wenn er gar
       keine Ueberschrift hat. Ein Klappkasten ohne Beschriftung waere sonst
       das Erste, was man sieht. */
    var kopfBlock = null;
    if (sauber.length && (!sauber[0].kopfEl || sauber[0].kopfEl.tagName === 'H2')) {
      kopfBlock = sauber.shift();
    }

    var offen = parseInt(guide.getAttribute('data-pww-guide-offen'), 10);
    if (isNaN(offen)) offen = 2;

    var lead = guide.querySelector('[data-pww-guide-lead]');

    /* Aufbau wie bei den Fragen: links Ueberschrift und Einleitung, rechts das
       Akkordeon. Auf schmalen Bildschirmen wird daraus von selbst eine
       Spalte – das regelt .pww-sec__grid aus der Produktseite. */
    var raster = document.createElement('div');
    raster.className = 'pww-sec__grid';

    var links = document.createElement('div');
    links.className = 'pww-guide__kopf';

    if (kopfBlock) {
      kopfBlock.knoten.forEach(function (k) {
        links.appendChild(k);
      });
      /* Der gepflegte Kurztext der Sammlung sitzt direkt unter der
         Ueberschrift, vor dem Einleitungssatz aus der Beschreibung. */
      if (lead) {
        var h = links.querySelector('h2');
        if (h && h.nextSibling) links.insertBefore(lead, h.nextSibling);
        else links.appendChild(lead);
      }
    } else if (lead) {
      links.appendChild(lead);
    }
    raster.appendChild(links);

    /* Alle Abschnitte werden zu Akkordeons – auch die, die beim Laden offen
       stehen. Vorher waren die ersten fest aufgeklappt und liessen sich nicht
       schliessen; wer nur die Tabelle sehen will, musste an allem vorbei
       scrollen. "offen" bestimmt jetzt nur noch, was beim Laden aufgeklappt
       ist. */
    var acc = document.createElement('div');
    acc.className = 'pww-acc';
    acc.setAttribute('data-pww-acc', '');

    sauber.forEach(function (b, i) {
      /* Letztes Sicherheitsnetz: ein Kasten ohne Beschriftung waere ein Knopf,
         von dem niemand weiss, was dahinter steckt. Sein Inhalt wandert in den
         Kopf. */
      if (!b.titel) {
        b.knoten.forEach(function (k) {
          links.appendChild(k);
        });
        return;
      }

      var startetOffen = i < Math.max(0, offen);

      var item = document.createElement('div');
      item.className = 'pww-acc__item' + (startetOffen ? ' is-open' : '');

      var btn = document.createElement('button');
      btn.className = 'pww-acc__btn';
      btn.type = 'button';
      btn.setAttribute('data-pww-acc-btn', '');
      btn.setAttribute('aria-expanded', startetOffen ? 'true' : 'false');
      btn.innerHTML =
        '<span></span><span class="pww-acc__chev">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' +
        '</span>';
      btn.querySelector('span').textContent = b.titel;

      var panel = document.createElement('div');
      panel.className = 'pww-acc__panel';
      b.knoten.forEach(function (k) {
        /* Die Ueberschrift steht schon auf dem Knopf. */
        if (k === b.kopfEl) return;
        panel.appendChild(k);
      });

      item.appendChild(btn);
      item.appendChild(panel);
      acc.appendChild(item);
    });

    raster.appendChild(acc);

    roh.remove();
    guide.appendChild(raster);
    tabellenFassen(guide);
    initAkkordeonAlle();
  }

  /* --------------------------------------------------- Schnellnavigation

     Die Nachbarkategorien stehen bereits in der Navigation – dort mit Symbol,
     Titel und Link. Statt dieselben Daten ein zweites Mal zu pflegen, wird die
     Zeile aus dem Mega-Panel gebaut: gesucht wird die Kachel, die auf die
     gerade gezeigte Sammlung zeigt, genommen werden ihre Geschwister.

     Findet sich nichts, bleibt die Zeile weg. Eine leere Leiste waere
     schlimmer als keine.

     Der Platz fuer die Zeile ist im CSS schon reserviert, solange sie noch
     versteckt ist – 46px plus Abstand. Ohne diese Reservierung erschien die
     Zeile erst, wenn dieses Skript gelaufen war, und schob Filterleiste und
     das ganze Raster um 64px nach unten. Genau die Art Sprung, die beim Laden
     auffaellt.

     Bleibt am Ende nichts uebrig, meldet is-leer das dem CSS und der Platz
     wird eingezogen. Dann verschiebt sich einmal etwas – aber nur auf den
     wenigen Kategorien ohne Nachbarn. */
  function initQuicknav(leiste) {
    if (!leiste || leiste.dataset.pwwInit === 'true') return;
    leiste.dataset.pwwInit = 'true';

    /* Ein Ausgang fuer alle Wege: entweder es steht etwas drin und die Zeile
       wird sichtbar, oder der reservierte Platz faellt weg. */
    function fertig() {
      if (leiste.children.length) leiste.hidden = false;
      else leiste.classList.add('is-leer');
    }

    var hier = window.location.pathname.replace(/\/$/, '');
    var kacheln = Array.prototype.slice.call(document.querySelectorAll('[data-pww-panel] .pww-cat'));
    if (!kacheln.length) return fertig();

    var treffer = null;
    kacheln.some(function (k) {
      var ziel = (k.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (ziel && ziel === hier) {
        treffer = k;
        return true;
      }
      return false;
    });

    var gruppe = treffer ? treffer.closest('.pww-cats') : null;

    /* Keine Kachel getroffen? Dann ist die Sammlung selbst ein Hauptpunkt der
       Navigation – etwa "Alltagshilfen". Dort sind die Unterkategorien nicht
       Geschwister, sondern die Kacheln des eigenen Panels. Ohne diesen Weg
       blieb die Zeile auf allen Hauptkategorien leer. */
    if (!gruppe) {
      var punkte = Array.prototype.slice.call(document.querySelectorAll('[data-pww-nav-item]'));
      punkte.some(function (item) {
        var link = item.querySelector('.pww-nav__link');
        var ziel = link ? (link.getAttribute('href') || '').split('?')[0].replace(/\/$/, '') : '';
        if (!ziel || ziel !== hier) return false;
        var panel = document.querySelector('[data-pww-panel="' + item.getAttribute('data-pww-nav-item') + '"]');
        gruppe = panel ? panel.querySelector('.pww-cats') : null;
        return !!gruppe;
      });
    }

    if (!gruppe) return fertig();

    /* Im Panel steht jede Kategorie mehrfach – einmal fuer "Alle", einmal fuer
       "Für Frauen", einmal fuer "Für Männer"; die Geschlechterwahl blendet um.
       Genommen wird nur, was gerade sichtbar ist, und jede Adresse nur einmal.
       Ohne das stand jede Kachel dreifach in der Zeile. */
    var gesehen = {};
    var geschwister = Array.prototype.slice.call(gruppe.querySelectorAll('.pww-cat')).filter(function (k) {
      if (k !== treffer && k.hidden) return false;
      var ziel = (k.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (!ziel || gesehen[ziel]) return false;
      gesehen[ziel] = true;
      return true;
    });
    if (geschwister.length < 2) return fertig();

    /* Die Ueberkategorie zuerst.

       Ohne sie zeigte die Zeile auf "Rollatoren" nur die vier Geschwister –
       Toilettenstuehle, WC-Sitzerhoehungen, Duschstuehle – und keinen Weg
       zurueck auf "Alltagshilfen". Wer von dort gekommen war, kam ueber die
       Zeile nicht zurueck. Die Brotkrume oben bot ihn zwar an, aber die ist
       klein und niemand sucht sie.

       Titel und Adresse stehen am Navigationspunkt, zu dem das Panel gehoert.
       Steht man selbst auf der Ueberkategorie, ist der Punkt markiert wie
       jede andere Kachel auch. */
    var panelWurzel = gruppe.closest('[data-pww-panel]');
    var panelSchluessel = panelWurzel ? panelWurzel.getAttribute('data-pww-panel') : null;
    var elternPunkt = panelSchluessel
      ? document.querySelector('[data-pww-nav-item="' + panelSchluessel + '"] .pww-nav__link')
      : null;

    if (elternPunkt) {
      var elternAdresse = (elternPunkt.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      var elternTitel = elternPunkt.textContent.replace(/\s+/g, ' ').trim();

      if (elternAdresse && elternTitel && !gesehen[elternAdresse]) {
        /* Das Symbol der Ueberkategorie steht schon im Dokument: die oberste
           Zeile des mobilen Menues traegt es, und sie ist ueber dieselbe
           Panel-Kennung zu finden. Es kommt aus der Einstellung "nav_icon" des
           Dropdown-Blocks – wer es dort wechselt, wechselt es hier mit.

           Findet sich keines, bleibt der Chip bei Text allein; die Hoehe haelt
           dann eine min-height im CSS. */
        var elternSymbol = document.querySelector(
          '[data-pww-open-view="' + panelSchluessel + '"] .pww-drawer__icon'
        );

        var eltern = document.createElement('a');
        eltern.className =
          'pww-plp__quicklink' +
          (elternSymbol ? '' : ' pww-plp__quicklink--nurtext') +
          (elternAdresse === hier ? ' is-hier' : '');
        eltern.href = elternPunkt.getAttribute('href');
        if (elternAdresse === hier) eltern.setAttribute('aria-current', 'page');

        if (elternSymbol) {
          var elternHuelle = document.createElement('span');
          elternHuelle.className = 'pww-plp__quickicon';
          elternHuelle.innerHTML = elternSymbol.innerHTML;
          eltern.appendChild(elternHuelle);
        }

        var elternText = document.createElement('span');
        elternText.textContent = elternTitel;
        eltern.appendChild(elternText);

        leiste.appendChild(eltern);
      }
    }

    geschwister.forEach(function (k) {
      var ziel = (k.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      var titel = k.querySelector('.pww-cat__title');
      if (!ziel || !titel) return;

      var a = document.createElement('a');
      a.className = 'pww-plp__quicklink' + (k === treffer ? ' is-hier' : '');
      a.href = k.getAttribute('href');
      if (k === treffer) a.setAttribute('aria-current', 'page');

      var symbol = k.querySelector('.pww-cat__icon');
      if (symbol) {
        var huelle = document.createElement('span');
        huelle.className = 'pww-plp__quickicon';
        huelle.innerHTML = symbol.innerHTML;
        a.appendChild(huelle);
      }

      var text = document.createElement('span');
      text.textContent = titel.textContent.trim();
      a.appendChild(text);

      leiste.appendChild(a);
    });

    fertig();
  }

  /* ------------------------------------------------------- Karten kaufen

     Direkt in den Warenkorb, ohne Seitenwechsel. Die Zahl im Kopf zieht
     pww-header.js nach – es horcht auf genau diese Anfrage. */
  function initKarten(wurzel) {
    if (!wurzel || wurzel.dataset.pwwKartenInit === 'true') return;
    wurzel.dataset.pwwKartenInit = 'true';

    /* is-wahl-offen hebt das Abschneiden der Karte auf, damit die Auswahl
       seitlich hinausragen darf. */
    function wahlZu(ausser) {
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-wahl]')).forEach(function (w) {
        if (w === ausser) return;
        w.hidden = true;
        var karte = w.closest('.pww-prod');
        if (karte) karte.classList.remove('is-wahl-offen');
      });
    }

    function legen(knopf, id) {
      if (!id || knopf.disabled) return;

      var karte = knopf.closest('.pww-prod');
      var anzeige = karte ? karte.querySelector('.pww-prod__add') : knopf;

      if (!window.fetch) {
        /* Ohne fetch der ehrliche Weg: auf die Produktseite. */
        var link = karte && karte.querySelector('.pww-prod__title');
        if (link) window.location.href = link.getAttribute('href');
        return;
      }

      knopf.disabled = true;
      if (anzeige) anzeige.classList.add('is-laeuft');

      window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (a) {
          if (!a.ok) throw new Error('HTTP ' + a.status);
          return a.json();
        })
        .then(function () {
          wahlZu(null);
          if (!anzeige) return;
          anzeige.classList.add('is-drin');
          window.setTimeout(function () {
            anzeige.classList.remove('is-drin');
          }, 1800);
        })
        .catch(function () {
          /* Nicht gelungen: auf die Produktseite, dort steht der richtige
             Knopf mit allen Angaben. */
          var ziel = karte && karte.querySelector('.pww-prod__title');
          if (ziel) window.location.href = ziel.getAttribute('href');
        })
        .then(function () {
          knopf.disabled = false;
          if (anzeige) anzeige.classList.remove('is-laeuft');
        });
    }

    /* ---- Bilder durchblaettern

       Der Stand haengt an der Buehne, nicht an einer Variablen: die Karten
       werden beim Filtern ausgetauscht und beim Nachladen ergaenzt. */
    function bilderVon(buehne) {
      var steuer = buehne.querySelector('[data-pww-bilder]');
      if (!steuer) return [];
      return (steuer.getAttribute('data-pww-bilder') || '').split('|').filter(Boolean);
    }

    function bildZeigen(buehne, neu) {
      var bilder = bilderVon(buehne);
      var oben = buehne.querySelector('.pww-prod__img2');
      if (bilder.length < 2 || !oben) return;

      if (neu < 0) neu = bilder.length - 1;
      if (neu > bilder.length - 1) neu = 0;
      buehne.dataset.pwwStand = String(neu);

      /* 0 ist das Grundbild darunter; alles Weitere wird in die obere Ebene
         geladen, die beim Zeigen mit der Maus ohnehin sichtbar ist. */
      if (neu === 0) {
        buehne.classList.add('is-grundbild');
        return;
      }
      buehne.classList.remove('is-grundbild');
      oben.removeAttribute('srcset');
      oben.setAttribute('src', bilder[neu]);
    }

    /* Ein einziger Zuhoerer fuer alle Karten – auch fuer die, die erst beim
       Nachladen dazukommen. Einzelne Zuhoerer je Knopf haetten die spaeter
       angehaengten Karten nicht erreicht. */
    wurzel.addEventListener('click', function (ev) {
      var add = ev.target.closest('[data-pww-add]');
      if (add) {
        ev.preventDefault();
        ev.stopPropagation();
        legen(add, add.getAttribute('data-pww-add'));
        return;
      }

      var auf = ev.target.closest('[data-pww-wahl-auf]');
      if (auf) {
        ev.preventDefault();
        ev.stopPropagation();
        var karte = auf.closest('.pww-prod');
        var feld = karte && karte.querySelector('[data-pww-wahl]');
        if (!feld) return;
        var oeffnen = feld.hidden;
        wahlZu(feld);
        feld.hidden = !oeffnen;
        if (karte) karte.classList.toggle('is-wahl-offen', oeffnen);
        return;
      }

      var vor = ev.target.closest('[data-pww-bild-vor]');
      var zurueck = ev.target.closest('[data-pww-bild-zurueck]');
      if (vor || zurueck) {
        ev.preventDefault();
        ev.stopPropagation();
        var buehne = (vor || zurueck).closest('.pww-prod__media');
        if (!buehne) return;
        var stand = parseInt(buehne.dataset.pwwStand, 10);
        if (isNaN(stand)) stand = 1;
        bildZeigen(buehne, stand + (vor ? 1 : -1));
      }
    });

    /* Beim Verlassen zurueck auf das zweite Bild – sonst zeigt die Karte
       spaeter ein Bild aus der Mitte, ohne dass jemand weiss warum. */
    wurzel.addEventListener(
      'mouseleave',
      function (ev) {
        var buehne = ev.target && ev.target.closest && ev.target.closest('.pww-prod__media');
        if (!buehne || !buehne.dataset.pwwStand) return;
        bildZeigen(buehne, 1);
      },
      true
    );
  }

  /* Klick daneben schliesst die Packungsauswahl. Einmalig am Dokument, nicht in
     initKarten – das laeuft je Abschnitt. */
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-pww-wahl], [data-pww-wahl-auf]')) return;
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-wahl]')).forEach(function (w) {
      w.hidden = true;
      var karte = w.closest('.pww-prod');
      if (karte) karte.classList.remove('is-wahl-offen');
    });
  });

  /* ------------------------------------------------------------ Filterleiste */

  function initPlp(wurzel) {
    if (!wurzel || wurzel.dataset.pwwInit === 'true') return;
    wurzel.dataset.pwwInit = 'true';

    var abschnittId = wurzel.getAttribute('data-pww-plp-section');
    var gruppen = wurzel.querySelector('[data-pww-plp-groups]');
    var leiste = wurzel.querySelector('[data-pww-plp-bar]');
    var blatt = wurzel.querySelector('[data-pww-plp-sheet]');
    var blattKoerper = wurzel.querySelector('[data-pww-plp-sheet-body]');
    var karten = wurzel.querySelector('[data-pww-plp-cards]');

    /* ---- Aufklapper */

    function alleZu(ausser) {
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-plp-panel]')).forEach(function (p) {
        if (p === ausser) return;
        p.hidden = true;
        var huelle = p.closest('[data-pww-plp-group], [data-pww-plp-sortwrap]');
        if (huelle) huelle.classList.remove('is-open');
        var knopf = huelle && huelle.querySelector('[aria-expanded]');
        if (knopf) knopf.setAttribute('aria-expanded', 'false');
      });
    }

    function aufklappen(knopf) {
      var huelle = knopf.closest('[data-pww-plp-group], [data-pww-plp-sortwrap]');
      if (!huelle) return;
      var panel = huelle.querySelector('[data-pww-plp-panel]');
      if (!panel) return;

      var wirdOffen = panel.hidden;
      alleZu(wirdOffen ? panel : null);
      panel.hidden = !wirdOffen;
      huelle.classList.toggle('is-open', wirdOffen);
      knopf.setAttribute('aria-expanded', wirdOffen ? 'true' : 'false');
    }

    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-plp-toggle], [data-pww-plp-sort-toggle]')).forEach(function (knopf) {
      knopf.addEventListener('click', function (ev) {
        ev.preventDefault();
        aufklappen(knopf);
      });
    });

    var mehrKnopf = wurzel.querySelector('[data-pww-plp-more]');
    if (mehrKnopf && gruppen) {
      var mehrText = mehrKnopf.querySelector('[data-pww-plp-more-text]');
      mehrKnopf.addEventListener('click', function () {
        var offen = gruppen.classList.toggle('is-more-open');
        mehrKnopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
        if (mehrText) {
          mehrText.textContent = offen
            ? mehrKnopf.getAttribute('data-pww-weniger-text') || 'Weniger Filter'
            : mehrKnopf.getAttribute('data-pww-mehr-text') || 'Weitere Filter';
        }
      });
    }

    /* ---- Filterblatt auf dem Handy

       Die Gruppen wandern beim Oeffnen hinein und danach an ihren Platz
       zurueck. So gibt es sie im Dokument nur einmal – zwei Saetze Filter
       waeren zwei Saetze Zustand, und einer davon irgendwann falsch. */

    var heimat = null;
    var blattTitel = wurzel.querySelector('.pww-plp__sheettitle');
    var blattTitelStandard = blattTitel ? blattTitel.textContent : '';

    /* nur: Kennung einer Gruppe. Dann steht im Blatt ausschliesslich diese –
       ein Tap auf "Grösse" soll die Groessen zeigen und nicht dazu noch vier
       weitere Filter, durch die man erst scrollen muss. Ohne Angabe kommen
       alle, das ist der Weg ueber den Knopf "Filter". */
    function blattAuf(nur) {
      if (!blatt || !gruppen || !blattKoerper) return;
      if (!heimat) heimat = { eltern: gruppen.parentNode, davor: gruppen.nextSibling };
      alleZu(null);
      blattKoerper.appendChild(gruppen);

      /* Kein is-more-open im Blatt: die Regel dafuer setzt die Gruppen wieder
         auf display:flex und schob den Gruppentitel neben die Werte statt
         darueber. Im Blatt macht das Aufdecken eine eigene Regel. */

      var titel = '';
      Array.prototype.slice.call(gruppen.querySelectorAll('[data-pww-plp-group]')).forEach(function (g) {
        var passt = !nur || g.getAttribute('data-pww-plp-gruppe') === nur;
        g.classList.toggle('is-aus', !passt);
        if (passt && nur) titel = g.getAttribute('data-pww-plp-titel') || '';
      });

      if (blattTitel) blattTitel.textContent = nur && titel ? titel : blattTitelStandard;

      blatt.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    /* Die Kreuze wieder auf den Stand der Adresse bringen.

       Beim Sammeln setzt das JS Kreuze, die noch nicht angewendet sind. Wird
       das Blatt ohne Anwenden geschlossen, blieben sie sonst stehen: die
       Uebersicht zeigte dann Filter als gesetzt, die es gar nicht waren. */
    function kreuzeAusAdresse() {
      var stand = standAusAdresse();
      Array.prototype.slice.call(wurzel.querySelectorAll('.pww-plp__value[data-pww-param]')).forEach(function (v) {
        var name = v.getAttribute('data-pww-param');
        var inhalt = v.getAttribute('data-pww-wert');
        var gesetzt = stand.getAll(name).indexOf(inhalt) > -1;
        v.classList.toggle('is-on', gesetzt);
      });
    }

    function blattZu() {
      if (!blatt || blatt.hidden) return;
      /* Vorgemerkte Auswahl verwerfen: beim naechsten Oeffnen wird wieder vom
         tatsaechlichen Stand der Seite aus gesammelt. */
      blattStand = null;
      blattVorschau = null;
      kreuzeAusAdresse();
      if (blattTakt) window.clearTimeout(blattTakt);
      blatt.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      if (blattTitel) blattTitel.textContent = blattTitelStandard;
      if (heimat && gruppen) {
        heimat.eltern.insertBefore(gruppen, heimat.davor);
        Array.prototype.slice.call(gruppen.querySelectorAll('[data-pww-plp-group]')).forEach(function (g) {
          g.classList.remove('is-aus');
        });
      }
    }

    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-plp-sheet-open]')).forEach(function (k) {
      k.addEventListener('click', function (ev) {
        ev.preventDefault();
        blattAuf(k.getAttribute('data-pww-plp-nur'));
      });
    });

    /* "Produkte anzeigen" wendet die gesammelte Auswahl an. Liegt die Vorschau
       schon vor, wird sie sofort eingesetzt – kein zweites Warten. Das Kreuz
       oben rechts schliesst dagegen ohne Anwenden; wer es drueckt, will die
       Auswahl nicht. */
    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-plp-sheet-close]')).forEach(function (k) {
      var wendetAn = k.classList.contains('pww-plp__sheetok');
      k.addEventListener('click', function () {
        if (!wendetAn || !blattStand) {
          blattZu();
          return;
        }

        /* Beides vor dem Schliessen sichern: blattZu verwirft den gesammelten
           Stand und die Vorschau. */
        var ziel = standAdresse(blattStand);
        var vorschau = blattVorschau;
        blattZu();

        if (vorschau && vorschau.url === ziel) {
          wurzel.innerHTML = vorschau.html;
          wurzel.setAttribute('data-pww-plp-params', vorschau.params);
          wurzel.dataset.pwwInit = '';
          initPlp(wurzel);
          Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-quicknav]')).forEach(initQuicknav);
          window.history.replaceState({}, '', ziel);
          return;
        }
        laden(ziel);
      });
    });

    if (blatt) {
      blatt.addEventListener('click', function (ev) {
        if (ev.target === blatt) blattZu();
      });
    }

    /* ---- Filter, Sortierung und Zuruecksetzen ohne Seitenwechsel */

    /* Wird die Vorlage zum Ansehen ueber ?view= aufgerufen, muss dieser
       Parameter mitwandern. Shopifys eigene Filteradressen bringen ihn mit,
       die von Hand gebauten (Sortieren, Zuruecksetzen) nicht – ohne diese
       Zeile faellt die Seite beim Zuruecksetzen auf die alte Vorlage zurueck.
       Ist die Vorlage der Sammlung fest zugewiesen, gibt es keinen Parameter
       und hier passiert nichts. */
    function ansichtErhalten(url) {
      var jetzt = new URLSearchParams(window.location.search).get('view');
      if (!jetzt || /[?&]view=/.test(url)) return url;
      var trenner = url.indexOf('?') > -1 ? '&' : '?';
      return url + trenner + 'view=' + encodeURIComponent(jetzt);
    }

    function adresseMitAbschnitt(url) {
      var trenner = url.indexOf('?') > -1 ? '&' : '?';
      return url + trenner + 'section_id=' + encodeURIComponent(abschnittId);
    }

    var laeuft = false;
    var wartet = null;

    function laden(rohUrl) {
      var url = ansichtErhalten(rohUrl);

      if (!window.fetch) {
        window.location.href = url;
        return;
      }

      /* Klick waehrend eine Anfrage laeuft: gemerkt und danach ausgefuehrt.
         Frueher wurde stattdessen hart neu geladen – wer zwei Filter schnell
         hintereinander setzte, bekam mitten im Vorgang einen Seitenwechsel. */
      if (laeuft) {
        wartet = url;
        return;
      }
      laeuft = true;
      if (karten) karten.classList.add('is-laedt');

      window.fetch(adresseMitAbschnitt(url), { credentials: 'same-origin' })
        .then(function (a) {
          if (!a.ok) throw new Error('HTTP ' + a.status);
          return a.text();
        })
        .then(function (html) {
          var kasten = document.createElement('div');
          kasten.innerHTML = html;
          var neu = kasten.querySelector('[data-pww-plp]');
          if (!neu) throw new Error('Abschnitt nicht gefunden');

          blattZu();
          wurzel.innerHTML = neu.innerHTML;
          wurzel.setAttribute('data-pww-plp-params', neu.getAttribute('data-pww-plp-params') || '');
          wurzel.dataset.pwwInit = '';
          initPlp(wurzel);
          /* pwwKartenInit bleibt stehen: die Zuhoerer haengen an der Wurzel,
             die hier nicht ausgetauscht wird. */
          Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-quicknav]')).forEach(initQuicknav);

          window.history.replaceState({}, '', url);

          /* Steht die Leiste ueber dem sichtbaren Bereich, waere das neue
             Ergebnis unsichtbar – dann nach oben zur Leiste. Sonst bleibt der
             Blick, wo er war. */
          var bar = wurzel.querySelector('[data-pww-plp-bar]');
          if (bar) {
            var oben = bar.getBoundingClientRect().top;
            if (oben < 0) {
              window.scrollTo({
                top: window.scrollY + oben - kopfHoehe() - 8,
                behavior: 'smooth'
              });
            }
          }
        })
        .catch(function () {
          /* Nachladen gescheitert: der Link tut, was er ohne Skript getan
             haette. Ein stiller Fehlschlag waere schlimmer. */
          window.location.href = url;
        })
        .then(function () {
          laeuft = false;
          if (karten) karten.classList.remove('is-laedt');
          if (wartet) {
            var naechste = wartet;
            wartet = null;
            /* Die Zuhoerer haengen am neuen Inhalt – ueber die Wurzel, die
               beim Austausch stehen bleibt. */
            var api = wurzel.pwwPlp;
            if (api && api.laden) api.laden(naechste);
          }
        });
    }

    /* ---- Auswahl im Filterblatt sammeln, statt sofort zu laden

       Im Blatt soll ein Kreuz nicht gleich die Liste neu holen: man setzt dort
       meist zwei oder drei Filter hintereinander, und jedes Mal neu zu laden
       riss die Auswahl unter den Fingern weg. Angekreuzt wird also nur
       vorgemerkt; geladen wird auf "Produkte anzeigen".

       Die Trefferzahl auf dem Knopf muss trotzdem stimmen. Darum wird im
       Hintergrund geholt, was die Auswahl ergaebe – und dasselbe Ergebnis beim
       Knopfdruck sofort eingesetzt, ohne zweite Anfrage. */
    var blattStand = null;
    var blattVorschau = null;
    var blattTakt = null;
    var okKnopf = wurzel.querySelector('.pww-plp__sheetok');
    var okText = okKnopf ? okKnopf.textContent.trim() : '';

    function standAusAdresse() {
      return new URLSearchParams(window.location.search);
    }

    function standAdresse(stand) {
      var kette = stand.toString();
      return wurzel.getAttribute('data-pww-plp-url') + (kette ? '?' + kette : '');
    }

    function vorschauHolen() {
      if (!blattStand || !window.fetch) return;
      var url = standAdresse(blattStand);

      window.fetch(adresseMitAbschnitt(url), { credentials: 'same-origin' })
        .then(function (a) {
          return a.ok ? a.text() : null;
        })
        .then(function (html) {
          if (!html) return;
          var kasten = document.createElement('div');
          kasten.innerHTML = html;
          var neu = kasten.querySelector('[data-pww-plp]');
          if (!neu) return;

          blattVorschau = { url: url, html: neu.innerHTML, params: neu.getAttribute('data-pww-plp-params') || '' };

          var zahl = neu.querySelector('[data-pww-plp-total] strong');
          if (okKnopf && zahl) {
            okKnopf.textContent = okText.replace(/^\d+/, zahl.textContent.trim());
          }
        })
        .catch(function () {
          /* Zahl bleibt stehen; der Knopf laedt dann eben normal. */
        });
    }

    function vorschauSpaeter() {
      if (blattTakt) window.clearTimeout(blattTakt);
      blattTakt = window.setTimeout(vorschauHolen, 300);
    }

    /* Kreuz im Blatt setzen oder entfernen – ohne zu laden. */
    function blattWaehlen(wert) {
      if (!blattStand) blattStand = standAusAdresse();

      var name = wert.getAttribute('data-pww-param');
      var inhalt = wert.getAttribute('data-pww-wert');
      if (!name || inhalt === null) return false;

      var an = !wert.classList.contains('is-on');
      if (an) {
        blattStand.append(name, inhalt);
      } else {
        var rest = blattStand.getAll(name).filter(function (x) {
          return x !== inhalt;
        });
        blattStand.delete(name);
        rest.forEach(function (x) {
          blattStand.append(name, x);
        });
      }
      wert.classList.toggle('is-on', an);

      /* Seitenzahl gehoert nicht in eine neue Auswahl. */
      blattStand.delete('page');

      vorschauSpaeter();
      return true;
    }

    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-plp-link]')).forEach(function (link) {
      link.addEventListener('click', function (ev) {
        var url = link.getAttribute('href');
        if (!url) return;
        ev.preventDefault();

        /* Im offenen Filterblatt wird gesammelt, sonst sofort geladen. */
        var imBlatt = blatt && !blatt.hidden && blatt.contains(link);
        if (imBlatt && link.classList.contains('pww-plp__value')) {
          if (blattWaehlen(link)) return;
        }
        if (imBlatt && link.classList.contains('pww-plp__sheetreset')) {
          blattStand = new URLSearchParams();
          Array.prototype.slice.call(blatt.querySelectorAll('.pww-plp__value.is-on')).forEach(function (v) {
            v.classList.remove('is-on');
          });
          vorschauSpaeter();
          return;
        }

        laden(url);
      });
    });

    /* ---- Weitere Produkte anhaengen */

    var weiter = wurzel.querySelector('[data-pww-plp-next]');
    var stand = wurzel.querySelector('[data-pww-plp-stand]');
    var hinweis = wurzel.querySelector('[data-pww-plp-laedt]');
    var laedtMehr = false;

    function mehrLaden() {
      if (laedtMehr || !weiter || !window.fetch) return;
      var url = weiter.getAttribute('href');
      if (!url) return;
      url = ansichtErhalten(url);

      laedtMehr = true;
      weiter.hidden = true;
      if (hinweis) hinweis.hidden = false;

      window.fetch(adresseMitAbschnitt(url), { credentials: 'same-origin' })
        .then(function (a) {
          if (!a.ok) throw new Error('HTTP ' + a.status);
          return a.text();
        })
        .then(function (html) {
          var kasten = document.createElement('div');
          kasten.innerHTML = html;

          var neueKarten = kasten.querySelector('[data-pww-plp-cards]');
          if (neueKarten && karten) {
            while (neueKarten.firstElementChild) {
              karten.appendChild(neueKarten.firstElementChild);
            }
          }

          var neuerStand = kasten.querySelector('[data-pww-plp-stand]');
          if (neuerStand && stand) stand.textContent = neuerStand.textContent;

          var neuesWeiter = kasten.querySelector('[data-pww-plp-next]');
          if (neuesWeiter && weiter) {
            weiter.setAttribute('href', neuesWeiter.getAttribute('href'));
            weiter.hidden = false;
          } else if (weiter) {
            /* Letzte Seite: Knopf und Hinweis verschwinden, der Zaehler
               bleibt stehen. */
            weiter.remove();
            weiter = null;
            if (beobachter) beobachter.disconnect();
          }

          /* Die Seitenzahl bewusst NICHT in die Adresse schreiben: beim
             Nachladen haengen die neuen Produkte an den alten. Stuende dann
             ?page=2 in der Adresse, zeigte ein Neuladen nur noch die zweite
             Haelfte – die ersten 24 Produkte waeren weg. */
        })
        .catch(function () {
          if (weiter) weiter.hidden = false;
        })
        .then(function () {
          laedtMehr = false;
          if (hinweis) hinweis.hidden = true;
        });
    }

    if (weiter) {
      weiter.addEventListener('click', function (ev) {
        ev.preventDefault();
        mehrLaden();
      });
    }

    /* Von selbst nachladen, sobald der Knopf in Sicht kommt. Der Knopf bleibt
       trotzdem da: er ist die Rueckfallebene und zeigt, dass es weitergeht. */
    var beobachter = null;
    if (weiter && window.IntersectionObserver) {
      beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) mehrLaden();
        });
      }, { rootMargin: '400px 0px' });
      beobachter.observe(weiter);
    }

    /* ---- Ein oder zwei Produkte je Zeile

       Die Wahl bleibt im Browser gespeichert: wer auf dem Handy einspaltig
       liest, will das nicht auf jeder Kategorieseite neu einstellen. */
    /* Schluessel mit Zaehler: am 18.08.2026 wurde der Standard auf dem Handy
       von einer auf zwei Karten je Zeile umgestellt. Wer vorher schon einmal
       hier war, trug die alte Wahl im Browser mit sich und sah weiterhin eine
       Karte – der neue Schluessel laesst die alte Eintragung liegen, sodass
       der neue Standard bei allen ankommt. Danach merkt sich der Browser die
       Wahl wieder wie gewohnt. */
    var ANSICHT_SPEICHER = 'pww-plp-ansicht-2';

    function ansichtSetzen(wert, merken) {
      var karten = wurzel.querySelector('[data-pww-plp-cards]');
      if (karten) karten.classList.toggle('is-eins', wert === '1');
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-ansicht]')).forEach(function (k) {
        k.classList.toggle('is-on', k.getAttribute('data-pww-ansicht') === wert);
      });
      if (!merken) return;
      try {
        window.localStorage.setItem(ANSICHT_SPEICHER, wert);
      } catch (e) {
        /* Privater Modus: dann gilt die Wahl nur fuer diese Seite. */
      }
    }

    var gemerkt = null;
    try {
      gemerkt = window.localStorage.getItem(ANSICHT_SPEICHER);
    } catch (e) {
      gemerkt = null;
    }
    if (gemerkt === '1' || gemerkt === '2') ansichtSetzen(gemerkt, false);

    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-ansicht]')).forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        ansichtSetzen(knopf.getAttribute('data-pww-ansicht'), true);
      });
    });

    /* Die Handgriffe nach aussen reichen. Die Zuhoerer an document und window
       haengen einmalig am Modul, nicht hier: initPlp laeuft nach jedem
       Filterklick erneut, und jeder Durchgang haette sonst einen weiteren
       Zuhoerer hinterlassen. */
    wurzel.pwwPlp = {
      alleZu: alleZu,
      blattZu: blattZu,
      laden: laden,
      leiste: leiste
    };
  }

  /* --------------------------------------------- Zuhoerer ausserhalb, einmalig */

  function jederPlp(tun) {
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-plp]')).forEach(function (w) {
      if (w.pwwPlp) tun(w.pwwPlp, w);
    });
  }

  document.addEventListener('click', function (ev) {
    jederPlp(function (api, w) {
      if (!w.contains(ev.target)) {
        api.alleZu(null);
        return;
      }
      if (!ev.target.closest('[data-pww-plp-panel], [data-pww-plp-toggle], [data-pww-plp-sort-toggle]')) {
        api.alleZu(null);
      }
    });
  });

  /* ------------------------------------------------------------- Umfrage

     Reiter am Rand, Umfrage im Overlay. Die Umfrage geht nie von selbst auf –
     wer sie sehen will, klickt den Reiter.

     Zigpolls Skript wird erst beim ersten Oeffnen geholt. Beim Laden der Seite
     mitzuladen hiesse, jedem Besucher eine fremde Datei aufzubuerden fuer
     etwas, das die wenigsten anklicken. */
  function initUmfrage(wurzel) {
    if (!wurzel || wurzel.dataset.pwwInit === 'true') return;
    wurzel.dataset.pwwInit = 'true';

    var reiter = wurzel.querySelector('[data-pww-umfrage-auf]');
    var lage = wurzel.querySelector('[data-pww-umfrage-lage]');
    var box = wurzel.querySelector('[data-pww-umfrage-box]');
    var laedt = wurzel.querySelector('[data-pww-umfrage-laedt]');
    if (!reiter || !lage || !box) return;

    var geholt = false;
    var vorherFokus = null;
    var wache = null;

    /* ---- Wer geantwortet hat, wird nicht mehr gefragt

       Der Abschluss wird im Browser vermerkt, je Umfrage-Nummer. Tauschst du
       im Theme-Editor die Umfrage aus, ist der Reiter fuer alle wieder da –
       eine neue Frage ist eine neue Frage.

       Nicht im Konto hinterlegt, sondern lokal: Zigpoll weiss zwar selbst, wer
       geantwortet hat, aber ihre Umfrage steckt in einem iframe auf fremder
       Adresse. Von aussen kommt man an deren Zustand nicht heran. */
    var SPEICHER = 'pww-umfrage-fertig';
    var umfrageNr = wurzel.getAttribute('data-pww-umfrage-poll');

    function schonGeantwortet() {
      try {
        return window.localStorage.getItem(SPEICHER) === umfrageNr;
      } catch (e) {
        /* Privater Modus: dann fragt der Reiter eben weiter. */
        return false;
      }
    }

    function alsFertigMerken() {
      try {
        window.localStorage.setItem(SPEICHER, umfrageNr);
      } catch (e) {}
    }

    function reiterWeg() {
      reiter.hidden = true;
      if (wache) {
        window.clearInterval(wache);
        wache = null;
      }
    }

    /* Ohne JS liesse sich nichts oeffnen, dann soll auch nichts zum Klicken
       einladen. Und wer schon geantwortet hat, sieht den Reiter nie wieder. */
    if (schonGeantwortet()) return;
    reiter.hidden = false;

    function skriptHolen() {
      if (geholt) return;
      geholt = true;

      window.Zigpoll = window.Zigpoll || {};
      window.Zigpoll.accountId = wurzel.getAttribute('data-pww-umfrage-konto');
      window.Zigpoll.pollId = wurzel.getAttribute('data-pww-umfrage-poll');

      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.charset = 'utf-8';
      s.src = 'https://cdn.zigpoll.com/static/js/main.js';
      s.async = true;
      s.onerror = function () {
        if (laedt) laedt.textContent = 'Die Umfrage laesst sich gerade nicht laden.';
      };
      document.head.appendChild(s);

      /* Der Ladehinweis verschwindet, sobald Zigpoll etwas in das Feld
         gestellt hat. Ein fester Zeitwert waere geraten – der Beobachter
         weiss es. */
      var feld = wurzel.querySelector('.pww-umfrage__inhalt > div');
      if (feld && laedt && window.MutationObserver) {
        var beobachter = new MutationObserver(function () {
          if (!feld.children.length) return;
          laedt.hidden = true;
          beobachter.disconnect();
        });
        beobachter.observe(feld, { childList: true, subtree: true });
      } else if (laedt) {
        laedt.hidden = true;
      }

      hakenSetzen();
    }

    /* ---- Zigpolls eigene Handgriffe abfangen

       Zigpoll legt am Fenster eine Schnittstelle offen. Zwei Stuecke daraus
       brauchen wir:

       _complete  ruft Zigpoll, wenn die Umfrage durchlaufen ist
       close      ruft Zigpoll, wenn ihr eigener Schliessen-Knopf gedrueckt
                  wird – der auf der letzten Folie steht

       Beide werden umhuellt, nicht ersetzt: das Original laeuft weiter, wir
       haengen nur unser Verhalten an. Ohne den close-Haken blieb nach ihrem
       Schliessen ein leerer weisser Kasten mit unserem Kreuz stehen.

       Die Handgriffe entstehen erst, wenn ihr Skript fertig ist – darum kurz
       nachfassen statt einmal zu schauen. */
    /* Sichtbarer Dank nach dem Abschicken. Zigpolls letzte Folie raeumt sich je
       nach Umfrage selbst ab; ohne Hinweis stuende man dann vor einem leeren
       Kasten und wuesste nicht, ob die Antwort angekommen ist. */
    function dankeZeigen() {
      var danke = wurzel.querySelector('[data-pww-umfrage-danke]');
      if (danke) danke.hidden = false;
    }

    /* Zigpolls Handgriffe umhuellen – und zwar dauerhaft.

       Frueher geschah das genau einmal: sobald _complete da war, wurde auch
       close umhuellt und der Takt gestoppt. Zigpoll baut seine Oberflaeche aber
       neu auf und ersetzt dabei seine eigenen Funktionen – danach lief ihr
       Schliessen an uns vorbei, und nach dem Abschluss blieb unser Fenster als
       leerer Kasten stehen. Die Marke sitzt jetzt an der Huelle selbst, nicht
       am Zigpoll-Objekt: so faellt ein Austausch auf und wird nachgezogen. */
    function huellen() {
      var z = window.Zigpoll;
      if (!z) return;

      if (typeof z._complete === 'function' && !z._complete.pwwHuelle) {
        var echtesComplete = z._complete;
        var neuesComplete = function () {
          /* Das Fenster bleibt offen: auf der letzten Folie steht der
             Rabattcode. Nur der Reiter geht – und der Dank erscheint. */
          alsFertigMerken();
          reiterWeg();
          dankeZeigen();
          return echtesComplete.apply(this, arguments);
        };
        neuesComplete.pwwHuelle = true;
        z._complete = neuesComplete;
      }

      if (typeof z.close === 'function' && !z.close.pwwHuelle) {
        var echtesClose = z.close;
        var neuesClose = function () {
          var ergebnis = echtesClose.apply(this, arguments);
          zu();
          return ergebnis;
        };
        neuesClose.pwwHuelle = true;
        z.close = neuesClose;
      }
    }

    function hakenSetzen() {
      var versuche = 0;
      var takt = window.setInterval(function () {
        versuche++;
        huellen();
        if (versuche >= 40) window.clearInterval(takt);
      }, 200);
    }

    /* Zweites Netz fuer den Abschluss: der Zustand statt des Handgriffs.

       Zigpoll baut seine Oberflaeche neu auf, wenn sich etwas aendert, und
       koennte _complete dabei ersetzen. submittedResponses dagegen bleibt –
       sobald dort eine Antwort steht, ist die Umfrage durch. Laeuft nur,
       solange das Fenster offen ist. */
    function abschlussBeobachten() {
      if (wache) return;
      wache = window.setInterval(function () {
        /* Huelle nachziehen, falls Zigpoll seine Funktionen ersetzt hat. */
        huellen();

        var z = window.Zigpoll;
        if (!z || !z.submittedResponses) return;
        if (!Object.keys(z.submittedResponses).length) return;

        alsFertigMerken();
        reiterWeg();
        dankeZeigen();

        /* Hat Zigpoll seine Oberflaeche selbst abgeraeumt, gibt es nichts mehr
           zu sehen – dann geht unser Fenster gleich mit zu, statt als leerer
           Kasten stehen zu bleiben. */
        var feld = wurzel.querySelector('.pww-umfrage__inhalt > div');
        if (feld && !feld.children.length) zu();
      }, 700);
    }

    function auf() {
      if (!lage.hidden) return;
      vorherFokus = document.activeElement;
      lage.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      skriptHolen();
      abschlussBeobachten();
      var kreuz = wurzel.querySelector('[data-pww-umfrage-zu]');
      if (kreuz) kreuz.focus();
    }

    function zu() {
      if (lage.hidden) return;
      lage.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      /* Der Beobachter braucht nur zu laufen, solange man antworten kann. */
      if (wache) {
        window.clearInterval(wache);
        wache = null;
      }
      /* Zurueck auf den Reiter, nicht ins Nichts. Kam der Fokus nicht von
         einem echten Element – etwa weil mit der Maus geklickt wurde – bleibt
         er sonst auf dem soeben versteckten Kreuz stehen, und die Tastatur
         faengt beim naechsten Tab wieder ganz oben an. */
      var ziel = vorherFokus;
      if (!ziel || ziel === document.body || !ziel.focus) ziel = reiter;
      if (!reiter.hidden || ziel !== reiter) ziel.focus();
      vorherFokus = null;
    }

    reiter.addEventListener('click', auf);

    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-umfrage-zu]')).forEach(function (k) {
      k.addEventListener('click', zu);
    });

    lage.addEventListener('click', function (ev) {
      if (ev.target === lage) zu();
    });

    /* Klaviyo hat Vorrang. Seine Formulare melden sich mit einem eigenen
       Ereignis; solange eines offen ist, verschwindet der Reiter und ein
       offenes Umfragefenster schliesst sich. Zwei Fenster uebereinander, beide
       mit einem anderen Rabatt, liest niemand als Absicht. */
    window.addEventListener('klaviyoForms', function (ev) {
      var art = ev && ev.detail && ev.detail.type;
      if (art === 'open') {
        zu();
        reiter.hidden = true;
      } else if (art === 'close' || art === 'submit' || art === 'redirectedToUrl') {
        /* Nur zurueckholen, wenn noch nicht geantwortet wurde – sonst braechte
           das Schliessen des Klaviyo-Fensters den Reiter wieder hervor, den
           der Abschluss gerade entfernt hat. */
        if (!schonGeantwortet()) reiter.hidden = false;
      }
    });

    wurzel.pwwUmfrage = { auf: auf, zu: zu };
  }

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    jederPlp(function (api) {
      api.alleZu(null);
      api.blattZu();
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-umfrage]')).forEach(function (u) {
      if (u.pwwUmfrage) u.pwwUmfrage.zu();
    });
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > MOBIL) {
      jederPlp(function (api) {
        api.blattZu();
      });
    }
  });

  /* Beim Scrollen wird nur noch der Schatten gesetzt, sobald die Leiste
     wirklich klebt. Wo sie klebt, entscheidet allein das CSS.

     Hoechstens einmal je gezeichnetem Bild: die Messung fragt Kopfzeile und
     Leiste nach ihrer Lage, und Scroll-Ereignisse kommen dichter als Bilder.
     Gleicher Griff wie proBild in pww-product.js. */
  var leistenTakt = null;
  window.addEventListener('scroll', function () {
    if (leistenTakt) return;
    leistenTakt = window.requestAnimationFrame(function () {
      leistenTakt = null;
      jederPlp(function (api) {
        if (!api.leiste) return;
        var oben = api.leiste.getBoundingClientRect().top;
        api.leiste.classList.toggle('is-stuck', Math.round(oben) <= kopfHoehe() + 1);
      });
    });
  }, { passive: true });

  /* ---------------------------------------------------------------- Start */

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-plp]')).forEach(function (w) {
      initPlp(w);
      /* Bewusst getrennt und ohne Zuruecksetzen: die Karten haengen an
         Zuhoerern der Wurzel, und die bleibt beim Filtern stehen – nur ihr
         Inhalt wird getauscht. Ein zweiter Durchgang wuerde die Zuhoerer
         verdoppeln. */
      initKarten(w);
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-quicknav]')).forEach(initQuicknav);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-umfrage]')).forEach(initUmfrage);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-guide]')).forEach(initGuide);
    /* Ratgeber und Fragen zusammen: die doppelten Striche stehen in beiden
       Texten, sie kommen aus derselben Pflege. */
    Array.prototype.slice.call(document.querySelectorAll('.pww-plp')).forEach(listenpunkteEntdoppeln);
    initAkkordeonAlle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor: Section wird neu gerendert */
  document.addEventListener('shopify:section:load', initAll);
})();
